import React, { useState } from 'react';
import { Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, Avatar, Button, ListItemText, Skeleton, Card, Menu, MenuItem, Typography } from '@mui/material'
import { ContentCut, Delete, NotificationsOff, MoreVert } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import notificationType from '../../../_constant/notification/notificationType';
import MenuComponent from '../../Menu/MenuComponent';
import ApiService from '../../../utils/ApiService';
import { useSelector } from 'react-redux';
import { identifierType, typeIndivisual } from '../../TypeComponent';
import userDefault from '../../../assets/images/userDefault.svg'
import eventdefault from '../../../assets/images/eventdefault.svg'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
const NotificationDataDrawer = ({ setNotificationList, notificationList, dispatch, closeDrawer, setGenaiWithPostType }) => {

    const navigate = useNavigate();
    const userData = useSelector((state) => state?.user?.userListName);
    const truncateText = (text, wordLimit) => {
        if (text) {
            const words = text.split(' ');
            return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
        } else {
            return text;
        }

    };

    const [currentItem, setCurrentItem] = useState(null);

    function deleteNotificationClickHandler(e, item) {
        console.debug("NotificationDataDrawer : deleteNotificationClickHandler : item : ", item);
        console.debug("NotificationDataDrawer : deleteNotificationClickHandler : item : notificationMessage : ", item?.data?.notificationMessage);
        let formBody = {
            ids: [item?.id],
        }
        ApiService.delete('softDeleteNotification', formBody).then(r => {
            let deletedNotification = notificationList.filter(d => d.id !== item.id)
            setNotificationList(deletedNotification)

        }).catch(e => {
            // console.error("NotificationDataDrawer : notificationUnReadHandler : unReadNotification : e : ", e);
        });

    }

    const loginUserId = userData.userId;
    // const loginUserId = 115;

    // Menu Meta
    // const readMenuItemsList = [
    //     { id: 1, name: "Generate Post", icon: <NotificationsOff />, onClick: (e, item) => generatePost(item) },
    //     { id: 2, name: "Mark as Unread", icon: <NotificationsOff />, onClick: markUnreadNotificationClickHandler },
    //     { id: 3, name: "Delete", icon: <Delete fontSize="small" />, onClick: (e, item) => deleteNotificationClickHandler(e, item) },
    // ];

    // const unReadMenuItemsList = [
    //     { id: 1, name: "Generate Post", icon: <NotificationsOff />, onClick: (e, item) => generatePost(item) },
    //     { id: 2, name: "Mark as Read", icon: <NotificationsOff />, onClick: markReadNotificationClickHandler },
    //     { id: 3, name: "Delete", icon: <Delete fontSize="small" />, onClick: (e, item) => deleteNotificationClickHandler(e, item) },
    // ];

    const menuItemsList = [
        { id: 1, name: "Generate Post", icon: <AutoAwesomeIcon />, onClick: (e, item) => generatePost(e, item) },
        // { id: 2, name: "Mark as Unread", icon: <NotificationsOff />, onClick: markUnreadNotificationClickHandler },
        { id: 3, name: "Delete", icon: <Delete fontSize="small" />, onClick: (e, item) => deleteNotificationClickHandler(e, item) },
    ];

    // const [menuItemsList, setMenuItemsList] = useState([]);
    const [anchorMenu, setAnchorMenu] = useState(null);

    const handleMenuOpen = (e, item) => {
        e.stopPropagation();
        e.preventDefault();
        setAnchorMenu(e.currentTarget);
        setCurrentItem(item);
    };

    const handleMenuClose = () => {
        setAnchorMenu(null);
        setCurrentItem(null);
    };

    // ./Menu Meta


    const bull = (
        <Box
            component="span"
            sx={{ display: 'inline-block', mx: '2px', transform: 'scale(2.8)', color: "#1D76FE" }}
        >
            •
        </Box>
    );

    function generatePost(e, item) {
        e.preventDefault();
        e.stopPropagation()
        let type = item?.type;
        localStorage.setItem('selectedTab', '/generative-ai');
        navigate(`/generative-ai?source=notification&purpose=${type}`);
        dispatch(closeDrawer("notification"))
    }

    function getNotificationImage(notificationData) {
        console.debug("NotificationDrawer : getNotificationImage : notificationData", notificationData);
        if (notificationData?.type) {
            switch (notificationData?.type) {
                case "notice":
                case 'post':
                    return (
                        < Avatar alt={notificationData.type} src={(notificationData?.data?.imageUrl != "null" && notificationData?.data?.imageUrl != null )|| eventdefault} sx={{ mx: 1, mt: 1, height: 50, width: 50 }
                        } variant='rounded' />
                    )
                    break;

                case "work-Anniversary":
                    return (
                        <Avatar alt={notificationData.type} src={(notificationData?.data?.imageUrl != "null" && notificationData?.data?.imageUrl != null )|| userDefault} sx={{ mx: 1, mt: 1, height: 50, width: 50 }} />
                    )
                    break;

                default:
                    return (
                        <Avatar alt="default avatar" src={(notificationData?.data?.imageUrl != "null" && notificationData?.data?.imageUrl != null )|| userDefault} sx={{ mx: 1, mt: 1, height: 50, width: 50 }} />
                    )
                    break;
            }
        } else {
            return (
                <Avatar alt="avatar" src={(notificationData?.data?.imageUrl != "null" && notificationData?.data?.imageUrl != null )|| userDefault} sx={{ mx: 1, mt: 1, height: 50, width: 50 }} />
            )
        }
    }

    function notificationReadHandler(notificationData) {
        console.debug("notificationdatadrawer: notification", notificationData?.id)
        let formBody = {
            read_at: 1,
            ids: [notificationData?.id],
            userId: loginUserId,
        }
        ApiService.put('readNotification', formBody).then(r => {
            // console.debug("NotificationDataDrawer : notificationReadHandler : unReadNotification : r : ", r);

        }).catch(e => {
            // console.error("NotificationDataDrawer : notificationReadHandler : unReadNotification : e : ", e);
        });
    }

    function onNotificationClickHandler(e, notificationData) {
        e.preventDefault();
        e.stopPropagation()
        notificationReadHandler(notificationData);

        dispatch(closeDrawer("notification"))
        // console.debug("NotificationDrawer : onNotificationClickHandler : notificationData", notificationData?.data?.attributes?.id && notificationData?.type);
        if (notificationData?.type == identifierType().comment || notificationData?.type == identifierType().postReact) {
            navigate(`/`)
        } else {
            if (notificationData?.data?.attributes?.id && notificationData?.type) {
                // navigate(getNotificationPageUrl(notificationData.type, notificationData.data.attributes.id));
                const state = { feedPostData: notificationData?.data?.attributes, feedPostName: typeIndivisual(notificationData?.type), indivisualAPI: typeIndivisual(notificationData?.type), reactPost: 'reactPost' }
                const route = `/feed/${notificationData?.data?.attributes?.id}`;
                navigate(route, { state: state });
            } else {
                navigate(`/`)
            }
        }
    }

    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <nav aria-label="main mailbox folders">

                <List>
                    {notificationList.map((data, dataIndex) => (
                        <ListItem
                            key={data.id}
                            disablePadding
                            sx={data.read_at != null ?
                                {
                                    backgroundColor: null,
                                    // backgroundColor: "#dce6f0",
                                    borderRadius: 1, mb: 2, border: '1px solid #dce6f0'
                                }
                                : {
                                    // backgroundColor: "rgb(219, 234, 254)",
                                    backgroundColor: "#DBEAFE",
                                    borderRadius: 1, mb: 2, border: '1px solid #dce6f0'
                                }
                            }
                        >
                            <ListItemButton sx={{ p: 1 }}
                                onClick={e => onNotificationClickHandler(e, data)}
                            >
                                <ListItemAvatar sx={{ alignSelf: "baseline", display: "flex" }}>
                                    {(data.read_at === 0 || data.read_at === null) && <span>{bull}</span>}
                                    {getNotificationImage(data)}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <Box display={'flex'} justifyContent={'space-between'}>
                                            <Typography variant="subtitle2">
                                                {/* {truncateText(data.data.message, 10)} */}
                                                {truncateText(data?.data?.notificationMessage, 10)}
                                            </Typography>
                                            <MoreVert onClick={e => handleMenuOpen(e, data)} />
                                            <MenuComponent
                                                index={dataIndex}
                                                menuItem={menuItemsList}
                                                menuActiveStatus={Boolean(anchorMenu && currentItem.id === data.id)}
                                                //  menuActiveStatus={openMenuIcon}
                                                handleMenuClose={handleMenuClose}
                                                anchorMenu={anchorMenu}
                                                itemValue={data}
                                            // selectedQuetionItem={props.selectedQuetionItem}
                                            />
                                        </Box>
                                    }

                                    secondary={
                                        <Typography my={0.5} varient='caption' sx={{
                                            fontSize: ".75rem"
                                        }}>{data?.created_at}</Typography>

                                    }

                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </nav>
        </Box >
    )
}

export default NotificationDataDrawer